import { useEffect } from 'react';
import { signalR } from 'src/signalR';
import { LOCAL_STORAGE_KEYS } from 'src/utils/constants/localStorageConstants';
import { useLocalStorage } from 'usehooks-ts';
interface UseSignalRProps<T = unknown> {
  methodName: string;
  callback: (data: T) => void;
  enabled?: boolean;
  markAsUnread?: boolean;
}

export const useSignalR = <T = unknown,>({
  methodName,
  callback,
  enabled = true,
  markAsUnread = true,
}: UseSignalRProps<T>) => {
  const [, setUnreadNotifications] = useLocalStorage(LOCAL_STORAGE_KEYS.unread_notifications, false);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    const wrappedCallback = (...args: unknown[]) => {
      callback(args[0] as T);
      if (markAsUnread) {
        setUnreadNotifications(true);
      }
    };

    signalR.addListener(methodName, wrappedCallback);

    return () => {
      signalR.removeListener(methodName, wrappedCallback);
    };
  }, [methodName, callback, enabled, markAsUnread]);

  return signalR;
};
